import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { AlertsService } from '../../alerts-custom.service';
import { AlertsvarService } from '../../alertsvar.service';
import { SharedService } from 'src/app/services/shared.service';
import { TimeZoneService } from 'src/app/services/time-zone.service';


@Component({
  selector: 'app-assign-user',
  templateUrl: './assign-user.component.html',
  styleUrls: ['./assign-user.component.scss']
})
export class AssignUserComponent implements OnInit, OnDestroy {

  selectedUser;
  filteredUsers = [];
  assignUserSpinnerState: boolean = false;
  $destroy: Subject<boolean> = new Subject()
  showErr:boolean=false

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private ref: MatDialogRef<AssignUserComponent>,
    private alertService: AlertsService,
    public alertVarService: AlertsvarService,
    private sharedService: SharedService,
    private timezoneservice: TimeZoneService
  ) { }

  searchValue = new FormControl('');

  userList: any = []

  ngOnInit(): void {

    this.filteredUsers = this.data.userlist
    this.searchValue.valueChanges.subscribe((searchstr) => {
      this.filteredUsers = [
        ...this.data.userlist.filter((item: any) => {
          return item.toLowerCase().includes(searchstr.toLowerCase())
        }),
      ]
    })
  }

  selectUser(user: any) {
    this.selectedUser = user;
  }

  cancelAssigUser() {
    this.ref.close();
  }

  submitAssignUser() {
    //console.log("AlertEvents", this.alertVarService.AlertEvents);
    if (this.selectedUser && this.selectedUser.value) {
      this.showErr=false
      this.assignUserSpinnerState = true;
      const selectedAlert = [];
      const excludeAlert = [];

      // this.data.selectedAlert.forEach((element: number) => {
      //   if (this.alertVarService.AlertEvents[element].isSelected) {
      //     selectedAlert.push({
      //       alertTime: this.alertVarService.AlertEvents[element].alerttime,
      //       seq_no: this.alertVarService.AlertEvents[element].seq_no
      //     })
      //   }
      // })

      if (!this.alertVarService.SelectAllAlerts) {

        Object.keys(this.alertVarService.eventWorkFlowInfo.selectedAlerts).map((batch: any) => {
          Object.keys(this.alertVarService.eventWorkFlowInfo.selectedAlerts[batch]).map((alertkey: any) => {
            selectedAlert.push(this.alertVarService.eventWorkFlowInfo.selectedAlerts[batch][alertkey])
          })
        })

      }
      else if (this.alertVarService.SelectAllAlerts) {
        Object.keys(this.alertVarService.eventWorkFlowInfo.selectedAlerts).map((batch: any) => {
          Object.keys(this.alertVarService.eventWorkFlowInfo.selectedAlerts[batch]).map((alertkey: any) => {
            if (!this.alertVarService.eventWorkFlowInfo.selectedAlerts[batch][alertkey]["selected"])
              excludeAlert.push(this.alertVarService.eventWorkFlowInfo.selectedAlerts[batch][alertkey])
          })
        })
      }
      // if (selectedAlert.length != 0) {
      //console.log("Selected Alerts", this.alertVarService.updateActionMetadata["states"]["status"]["1"]["disp"]);
      const assignReqObj = {
        username: this.sharedService.userName,
        alertId: this.alertVarService.alertscollapsedata.selectedalert.alertId,
        selectedAlert: selectedAlert,
        exemptedAlert: excludeAlert,

        assigned_user: this.selectedUser.value,
        status: 1,//open assign
        action: this.alertVarService.updateActionMetadata["states"]["status"]["1"]["disp"],
        bulk_action: this.alertVarService.SelectAllAlerts,
        template: this.alertVarService.SelectAllAlerts ? { ...this.alertVarService.template_structure } : {},
        selectednode: this.alertVarService.nodeinfo.id,
        season_time: [this.timezoneservice.toUtcTimeZonefromUser(this.alertVarService.advanced_filter_values.start_time).format("YYYY-MM-DD HH:mm:ss"), this.timezoneservice.toUtcTimeZonefromUser(this.alertVarService.advanced_filter_values.end_time).format("YYYY-MM-DD HH:mm:ss")],
        status_filter: [],
        state_filter: [],
        statusreason_filter: []
      }
      this.alertService.postAssignedUers(assignReqObj)
        .pipe(takeUntil(this.$destroy))
        .subscribe((res) => {
          this.assignUserSpinnerState = false;
          this.ref.close(true);
          if (res["status"]) {
            // this.updateEventList();
            this.alertVarService.createtoastmsg({
              type: "success",
              "text": "Alerts Assigned to " + this.selectedUser.disp
            })
            this.alertVarService.clearAllPageClick()
            this.alertVarService.$alertStatusUpdated.next(true);
          }
        },
          (err) => {
            this.assignUserSpinnerState = false;
            this.ref.close(true);
            this.alertVarService.createtoastmsg({
              type: "error",
              "text": err.error.message || "Failed to assign user"
            })
          })
    }
    else {
      this.showErr=true
      // this.alertVarService.createtoastmsg({
      //   type: "success",
      //   "text": "Alerts Assigned to specific user"
      // })
    }

    // }
  }

  updateEventList() {
    this.data.selectedAlert.forEach((element) => {
      this.alertVarService.AlertEvents[element].assigned_to = this.selectedUser.value;
      this.alertVarService.AlertEvents[element].status = 1;
      this.alertVarService.alertWorkFlowInfo.selectedAlerts[element].assigned_to = this.selectedUser.value;
      this.alertVarService.alertWorkFlowInfo.selectedAlerts[element].status = 1;
    })
    //this.alertVarService.eventlist = [...this.alertVarService.eventlist];
  };

  ngOnDestroy(): void {
    this.$destroy.next(true);
  }

}
